import BaseService from "services/base";
import { builder } from "utils/graphql";
import { SHOP_DAY_OFF_SELECTION } from "./constant";

class ShopDayOffService extends BaseService {
  static override DEFINITION = builder.createDefinition({
    name: "ShopDayOff",
    baseQuery: "ShopDayOff",
    baseSelection: `
      ${SHOP_DAY_OFF_SELECTION}
    `,
    GQL_SHAPE_QUERY: {
      BASE: `
        {{ selections }}
      `,
      FIND: `
        docs {
          {{ selections }}
        }
      `,
      UPDATE: `
          {{ selections }}
      `,
    },
    GQL_ACTIONS: {
      FIND: "ShopDayOffs",
      CREATE: "createShopDayOff",
      UPDATE: "updateShopDayOff",
      DELETE: "deleteShopDayOff",
    },
    GQL_RESPONSE_DATA_PATH: {
      BASE: "data.ShopDayOff",
      CREATE: "data.createShopDayOff",
      FIND: "data.ShopDayOffs.docs",
      UPDATE: "data.updateShopDayOff",
      PARAMS: "data.ShopDayOffs",
    },
  });
}
// export * from "./formatter";

const Instance = new ShopDayOffService();
export default Instance;
